module.exports = __webpack_public_path__ + "img/idcard1.2bd189a6.png";